import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { map } from 'rxjs/operators';
import { BASE_URL } from '../config';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(
    private http: Http
  ) { }


  getNews(page, limit) {

    const url = `${BASE_URL}/noticias.php?p=${page}&limite=${limit}`;
    return this.http.get(url)
    .pipe(
      map(
        res => res.json()
      )
    );
  }

  getDetailNews(id: number) {

    const url = `${BASE_URL}noticia.php`;

    return this.http.post(url, {id: id})
    .pipe(
      map(
        res => res.json()
      )
    );

  }

}
